export default __webpack_public_path__ + "static/media/paint-brush-2.52243f91.png";